import { render, staticRenderFns } from "./recom.vue?vue&type=template&id=6b2cab6b&scoped=true&"
import script from "./recom.vue?vue&type=script&lang=js&"
export * from "./recom.vue?vue&type=script&lang=js&"
import style0 from "./recom.vue?vue&type=style&index=0&id=6b2cab6b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2cab6b",
  null
  
)

export default component.exports